import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ynyj2tklh3: FaireBrandEntity = {
  token: "b_ynyj2tklh3",
  type: "brand",
  name: "Starry Knight Design",
  avatarUrl:
    "https://cdn.faire.com/fastly/cb76de15d79e069e1a3d91530cc04ac385b0a7b9ed0d2f40b8e22284c8620694.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c775eb9ad18a5f783c28ccebc003434117d2e506a5486a6796e7818ad0bdf132.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cb76de15d79e069e1a3d91530cc04ac385b0a7b9ed0d2f40b8e22284c8620694.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c775eb9ad18a5f783c28ccebc003434117d2e506a5486a6796e7818ad0bdf132.jpeg",
  location: "Corvallis, MT, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 74,
  isTopShop: true,
  isInsider: true,
  description:
    "Starry Knight Design shoes are handmade in Montana USA by a team of local women with high-quality 100% leather and suede. Since 2008, We have been designing and making soft soled leather shoes for your tiny babies up to kids.  Our Shoes are great for ages newborn to 4years:\n\n-Soft and non restrictive  for developing feet\n\n-Soft Elastic  band around ankle \n\n-Help keep socks on newborns\n\n-great for babies crawling around\n\n-perfect for balance when they start standing and walking \n\n-suede bottoms help make non slip for floors\n\n-good for house/daycare shoes for toddlers! Or with our Add on soles even outdoor shoes Starry Knight Design Shoes\n\n-- 100% high quality leather and suede\n\n-- Handmade in Montana USA ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.213Z",
    importedBy: "entity-db-cli",
  },
};
